import React, { Component } from 'react';
import _ from 'lodash';
import common from 'ui-react-common';
import PropTypes from 'prop-types';

const config = common.config;
const Select = common.ui.components.forms.Select;

export const validation = {
    validateOn: ['blur'],
    required: true,
    message: {
        default: 'Please select a loan purpose',
    },
};

export const loanTypes = _.map(config.global.loanTypes, (loanType, key) => ({
    text: loanType,
    value: key,
}));

class LoanPurpose extends Component {
  static propTypes = {
      value: PropTypes.string,
      helper: PropTypes.string
  };

  render() {
      return (
          <Select
              id="loanPurpose"
              name="loanPurpose"
              type="text"
              placeholder="What is the loan for?"
              options={loanTypes}
              validation={validation}
              value={this.props.value}
              usePlaceholderOption
              helper={this.props.helper}
          />
      );
  }
}

export default LoanPurpose;
